/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_NewInputs */

const cs_action_new = /** @type {(inputs: Action_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový`)
};

const en_action_new = /** @type {(inputs: Action_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Action_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_new = /** @type {((inputs?: Action_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_new(inputs)
	return cs_action_new(inputs)
});